<template>
  <zm-alert
    v-if="showZcmDomainWarning"
    :title="$t('billing.zcm.domain_restriction_warning')"
    type="warning"
    show-icon
    :closable="true"
    class="opc-cart__zcm-domain-warning"
    @close="handleClose"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ZcmDomainWarning',
  computed: {
    ...mapGetters(['zcmDomainWarning']),
    
    showZcmDomainWarning() {
      return this.zcmDomainWarning;
    }
  },
  
  methods: {
    ...mapMutations(['setZcmDomainWarning']),
    
    handleClose() {
      this.setZcmDomainWarning(false);
    }
  }
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-cart__zcm-domain-warning {
  margin-bottom: 16px;
  font-size: 14px;
  
  @include media(mobile, tablet) {
    margin-bottom: 12px;
  }
}
</style>
